import { Component, Input } from '@angular/core';
import { EChartsOption, graphic } from 'echarts';
import { catchError, finalize, tap } from 'rxjs';
import moment from 'moment';
import { AppService } from '../../../../../app.service';
import { ReportsService } from '../../../../../services/reports/reports.service';
import { isArrayWithData } from '../../../../../utilities/array.helpers';
import { ChartColorUtils } from '../../../../../utilities/color.helpers';

@Component({
    selector: 'email-errors',
    templateUrl: './email-errors.component.html',
    styleUrl: './email-errors.component.css',
})
export class EmailErrorsComponent {
    constructor(
        private reportsService: ReportsService,
        public appService: AppService,
    ) {}

    isArrayWithData = isArrayWithData;

    todaysDate: Date = new Date();

    fromDate: Date = new Date();
    toDate: Date = new Date();
    failureDetailsStartsWith?: string;
    failureDetailsStartsWith_Display?: string;
    recordCount?: number;

    tableData: any;
    totalCount: number = 0;

    chartOptionsPie: EChartsOption | null = null;

    ngOnInit() {
        this.getGraph();
    }

    getGraph() {
        this.failureDetailsStartsWith_Display = this.failureDetailsStartsWith;
        this.appService.isShowPageSpinner = true;
        this.reportsService
            .getGraphEmailErrors(
                moment(this.fromDate).format('YYYY-MM-DD'),
                moment(this.toDate).format('YYYY-MM-DD'),
                this.failureDetailsStartsWith,
                this.recordCount,
            )
            .pipe(
                tap((res: any) => {
                    this.chartOptionsPie = null;

                    this.generateVisuals(res);
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    }

    mockData = () => {
        const rawDataWithErrorCode = [
            {
                creditorId: 195,
                errorCode: '30007',
                count: 1960,
            },
            {
                creditorId: 195,
                errorCode: '30003',
                count: 1247,
            },
            {
                creditorId: 56,
                errorCode: '30007',
                count: 348,
            },
            {
                creditorId: 56,
                errorCode: '30007',
                count: 106,
            },
            {
                creditorId: 56,
                errorCode: '30003',
                count: 99,
            },
            {
                creditorId: 228,
                errorCode: '30003',
                count: 98,
            },
            {
                creditorId: 79,
                errorCode: '30007',
                count: 71,
            },
            {
                creditorId: 64,
                errorCode: '30002',
                count: 46,
            },
            {
                creditorId: 68,
                errorCode: '30007',
                count: 38,
            },
            {
                creditorId: 68,
                errorCode: '30003',
                count: 36,
            },
        ];
        this.generateVisuals(rawDataWithErrorCode);
    };

    generateVisuals(rawData: any) {
        // OPTIONAL
        ChartColorUtils.reset();

        const graphData_SpecificErrorCode = rawData.map((x: any) => ({
            name: `creditor/${x.creditorId}`,

            value: x.count,

            errorCode: x.errorCode,

            // UNIQUE COLOR PER SLICE
            color: ChartColorUtils.getColor(`${x.creditorId}-${x.errorCode}`),
        }));

        this.totalCount = graphData_SpecificErrorCode.reduce(
            (sum: number, item: any) => sum + item.value,
            0,
        );

        this.chartOptionsPie = {
            tooltip: {
                trigger: 'item',

                formatter: (p: any) => `
                <b>${p.name}</b><br/>
                Error Code: ${p.data.errorCode}<br/>
                Count: ${p.value.toLocaleString()}<br/>
                ${p.percent}%
            `,
            },

            series: [
                {
                    type: 'pie',

                    radius: ['62%', '88%'],

                    center: ['50%', '52%'],

                    label: {
                        formatter: '{d}%',
                        fontWeight: 600,
                        fontSize: 18,
                    },

                    labelLine: {
                        length: 18,
                        length2: 14,
                    },

                    data: graphData_SpecificErrorCode.map((x: any) => ({
                        value: x.value,

                        name: x.name,

                        errorCode: x.errorCode,

                        itemStyle: {
                            color: x.color,
                        },
                    })),
                },
            ],

            graphic: [
                {
                    type: 'text',
                    left: 'center',
                    top: '43%',
                    style: {
                        text: 'Total',
                        fill: '#222',
                        fontSize: 20,
                        fontWeight: 600,
                    },
                },
                {
                    type: 'text',
                    left: 'center',
                    top: '49%',
                    style: {
                        text: this.totalCount.toLocaleString(),
                        fill: '#111',
                        fontSize: 38,
                        fontWeight: 700,
                    },
                },
            ],
        };

        this.generateTable(rawData, graphData_SpecificErrorCode);
    }
    generateTable = (rawData: any, graphData_SpecificErrorCode: any) => {
        this.tableData = rawData.map((item: any, index: number) => ({
            creditorId: `creditor/${item.creditorId}`,
            errorCode: item.errorCode,
            count: item.count,
            percent: ((item.count / this.totalCount) * 100).toFixed(1),
            color: graphData_SpecificErrorCode[index].color,
        }));
    };
}
